// import React, { useState } from "react";
// import QavachStaffTable from "../components/QavachStaffTable";
// import TeleSpecialistTable from "../components/TeleSpecialistTable";
// import '../css/OnboardUsersPage.css'

// const OnboardUsersPage: React.FC = () => {
//   const [activeTab, setActiveTab] = useState("qavach");

//   return (
//     <div className="onboard-page">
//       {/* Top Tab */}
//       <div className="top-tabs">
//         <button
//           className={activeTab === "qavach" ? "tab active" : "tab"}
//           onClick={() => setActiveTab("qavach")}
//         >
//           Qavach Staff
//         </button>
//         <button
//           className={activeTab === "tele" ? "tab active" : "tab"}
//           onClick={() => setActiveTab("tele")}
//         >
//           Tele-Specialist
//         </button>
//       </div>

//       {/* Render Tables */}
//       <div className="tab-content">
//         {activeTab === "qavach" && <QavachStaffTable />}
//         {activeTab === "tele" && <TeleSpecialistTable />}
//       </div>
//     </div>
//   );
// };

// export default OnboardUsersPage;



import React, { useState } from "react";
import QavachStaffTable from "../../components/Super Admin/Core Functions/QavachStaffTable";
import QavachSpecialistTable from "../../components/Super Admin/Core Functions/TeleSpecialistTable";
import ReferralDoctorTable from "../../components/Super Admin/Core Functions/ReferralDoctorTable";
// We don't need the Sidebar import here
import TopTabs from "../../components/Super Admin/TopBar/TopbarCoreFunctions";
import "../../css/OnboardUsersPage.css"; // We will update this file

const OnboardUsersPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"staff" | "specialist" | "referral">("staff");

  return (
    // 🛑 REMOVED the "forms-page" and "main-content" divs.
    // We use a Fragment so this content renders directly into the LayoutWithSidebar's <Outlet>
    <>
      <TopTabs />

      <div className="onboard-users-container"> {/* Renamed */}
        {/* Page-specific Tabs */}
        <div className="onboard-users-tabs"> {/* Renamed */}
          <button
            className={activeTab === "staff" ? "active" : ""}
            onClick={() => setActiveTab("staff")}
          >
            Qavach Staff
          </button>
          <button
            className={activeTab === "specialist" ? "active" : ""}
            onClick={() => setActiveTab("specialist")}
          >
            Tele Specialist
          </button>
          <button
            className={activeTab === "referral" ? "active" : ""}
            onClick={() => setActiveTab("referral")}
          >
            Referral Doctor
          </button>
        </div>

        {/* Table Content */}
        <div className="onboard-users-tab-content"> {/* Renamed */}
          {activeTab === "staff" && <QavachStaffTable />}
          {activeTab === "specialist" && <QavachSpecialistTable />}
          {activeTab === "referral" && <ReferralDoctorTable />}
        </div>
      </div>
    </>
  );
};

export default OnboardUsersPage;